import { Component, OnInit } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Globals } from 'src/app/globals';
import { ChartType, ChartOptions } from 'chart.js';
import {
  MultiDataSet, Label,
  // SingleDataSet,
  monkeyPatchChartJsLegend, monkeyPatchChartJsTooltip
} from 'ng2-charts';
import { AdmService } from 'src/app/service/adm.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  // doughnutChartLabels: Label[] = ['New Cand', 'Pend Cand', 'Approved Cand'];
  // doughnutChartData: MultiDataSet = [
  //   [55, 25, 20]
  // ];
  doughnutChartLabels: Label[] = [];
  doughnutChartData: MultiDataSet = [];
  doughnutChartType: ChartType = 'doughnut';

  admStatusData: any = [];
  candDashBoardData: any = [];
  showLoader = false;
  isCand = false;

  // Second one
  // public pieChartOptions: ChartOptions = {
  //   responsive: true,
  // };
  // public pieChartLabels: Label[] = [['New Cand'], ['Pend Cand'], 'Approved Cand'];
  // public pieChartData: SingleDataSet = [30, 50, 20];
  // public pieChartType: ChartType = 'pie';
  // public pieChartLegend = true;
  // public pieChartPlugins = [];

  constructor(public translate: TranslateService, public globals: Globals, private admService: AdmService, private toastr: ToastrService, private router: Router) {
    monkeyPatchChartJsTooltip();
    monkeyPatchChartJsLegend();
  }

  ngOnInit(): void {
    if (typeof this.globals.candidateId != undefined && this.globals.candidateId != null && this.globals.candidateId !=0) {
      this.isCand = true;
    }
    if (!this.isCand) {
      this.getAdmDashboardStatus();
    }

    // Listen for language change to update table
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      if (this.admStatusData.length > 0) {
        this.updateStatusChartData();
      }
      this.updateTable();
    });
  }

  getAdmDashboardStatus() {
    this.showLoader = true;
    this.admService.getAdmDashboardStatus(this.globals.currentUserInfo.username).subscribe(
      data => {
        this.admStatusData = data;
        if (data.length > 0) {
          this.updateStatusChartData();
        } else {
          this.toastr.warning(this.translate.instant('NO_STATUS_FOUND'));
        }

      },
      error => {
        this.toastr.error(this.translate.instant('CAN_NOT_GET_ADM_DASHBOARD_STATUS'));
      },
      () => this.getAdmDashboardPending()
    );
  }

  getAdmDashboardPending() {
    this.admService.getAdmDashboardPending(this.globals.currentUserInfo.username).subscribe(
      data => {
        this.candDashBoardData = data;
        this.updateTable();
        this.showLoader = false;
      },
      error => {
        this.showLoader = false;
        this.toastr.error(this.translate.instant('CAN_NOT_GET_PENDING_CAND'));
      });
  }

  updateStatusChartData() {
    if (this.admStatusData.length > 0) {
      let labels: any = [];
      let values: any = [];
      this.admStatusData.forEach((element: any) => {
        if (this.globals.lang == 'en') {
          labels.push(element.statusEn);
        } else {
          labels.push(element.statusAr);
        }
        values.push(element.appNo);
      });

      this.doughnutChartLabels = labels;
      this.doughnutChartData = values;

    }
  }

  updateTable() {
    $("#datatable").DataTable().destroy();
    setTimeout(() => {
      $("#datatable").DataTable({
        pagingType: 'simple_numbers',
        pageLength: 5,
        lengthChange: false,
        info: true,
        searching: false,
        // search: {
        //   searchPlaceholder: "Search",
        // },
        paging: true,
        // language: {
        //   search: "",
        //   searchPlaceholder: "Search",
        // },
      });
    }, 1);
  }

  Preview(candidateId: number) {
    this.router.navigate(['/admission/cand-preview'],
      { queryParams: { candId: candidateId } });
  }

}
